<template>
  <div class="text-2xl font-semibold pr-10">
    {{ $t(props.titleKey) }}
  </div>

  <UButton
    v-if="props.onDismiss"
    class="absolute top-5 right-4 sm:right-6 bg-gray-50 dark:bg-gray-800/75 rounded-full"
    icon="i-heroicons-x-mark"
    variant="ghost"
    color="white"
    @click.stop.prevent="props.onDismiss"
  />
</template>

<script setup lang="tsx">
const props = defineProps(["titleKey", "onDismiss"]);
</script>
